// extracted by mini-css-extract-plugin
export default {"customFields":"styles_customFields__kY3NI"};